/* mo-pvt-cut.js: the cut showpiece of the Purple vs Tempur-Pedic article (snippets/mo-pvt-cut.liquid), Mattress
   Overstock, 2026-10-15.
   Top row: one bed from each brand cut open on one floor line at one scale (px per inch), each layer at the depth the
   maker publishes. Where a maker publishes no depth, that part of the bed is hatched and says "not published".
   Bottom row: the same press on both comfort layers, close up and not to scale. Purple's GelFlex Grid walls buckle
   under the point of the load and spring straight the moment it lifts, while the walls beside it stand; TEMPUR spreads
   the load into a wide, smooth dent, sinks in slowly, warms where it is pressed, and fills back in slowly after the
   load lifts. It shows
   the idea, not a measurement.
   The same svg() runs in Node to write the server still (build_still.js), so the live drawing lands on the still.
   Plain JS, no library. Animates only while something moves and the figure is on screen. */
(function () {
  'use strict';

  // band class per layer kind
  var KIND = { cover: 'cv', grid: 'gd', comfort: 'fm', tempur: 'tp', relief: 'rl', purecool: 'pc', hybrid: 'hy', zone: 'zn', support: 'sp', coils: 'co', dstack: 'co', base: 'bs', other: 'fm' };
  var WORD = { grid: 'GelFlex Grid', comfort: 'Comfort foam', tempur: 'TEMPUR', relief: 'Advanced Relief', purecool: 'Pure Cool', hybrid: 'Hybrid material', zone: '5-zone support', support: 'Support foam', base: 'Base foam', other: 'Foam', dreamlayer: 'DreamLayer' };
  var SIG = { grid: 'a', tempur: 'b', relief: 'b', purecool: 'b' };

  function G(narrow) {
    if (narrow) return { W: 360, s: 10, floor: 236, ax: 62, bx: 200, w: 98, gx: 181, cy: 262, ch: 104, lab: 54, n: 9, f2: 12, bo: 6 };
    return { W: 640, s: 11.5, floor: 252, ax: 96, bx: 348, w: 196, gx: 322, cy: 282, ch: 112, lab: 88, n: 15, f2: 12, bo: 9 };
  }

  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function r1(v) { return Math.round(v * 10) / 10; }
  function num(v) { return (Math.round(v * 100) / 100).toString(); }

  // ------------------------------------------------------------------ the to-scale cut
  // Layers top down: [name, inches or null, kind, cm or null]. A cover with no published depth is the top line.
  // Every layer with a published depth is drawn at that depth, in the maker's order, down from the bed's published
  // height. What is left of the height goes to the layers with no published depth, split evenly and hatched: the
  // drawing claims no depth for them. If the published depths add up to more than the height, the stack starts that
  // much higher (Purple prints 9.25 in. for the Purple Mattress and layers of 2, 3.5 and 4 in.).
  function bands(bed, g) {
    var L = (bed.layers || []).filter(function (l) { return !(l[2] === 'cover' && l[1] == null); });
    var known = 0, unknown = 0, i, out = [], sig = 0, sigCm = false, sigKind = null;
    for (i = 0; i < L.length; i++) { if (L[i][1] == null) unknown++; else known += L[i][1]; }
    var H = Math.max(bed.h, known), rest = Math.max(0, bed.h - known), each = unknown ? rest / unknown : 0;
    var y = g.floor - H * g.s;
    if (!unknown && rest > 0.05) { out.push({ n: -1, kind: 'np', name: 'Cover', names: ['Cover'], d: null, y: y, h: rest * g.s, gap: true }); y += rest * g.s; }
    for (i = 0; i < L.length; i++) {
      var d = L[i][1], h = (d == null ? each : d) * g.s;
      out.push({ n: i, kind: d == null ? 'np' : L[i][2], name: L[i][0], names: [L[i][0]], d: d, cm: L[i][3] || null, coils: (L[i][2] === 'coils' || L[i][2] === 'dstack') ? L[i][2] : false, y: y, h: h });
      y += h;
      if (d != null && SIG[L[i][2]]) { sig += d; if (L[i][3]) sigCm = true; sigKind = L[i][2] === 'grid' ? 'grid' : 'comfort'; }
    }
    return { top: g.floor - H * g.s, list: out, sig: sig, sigCm: sigCm, sigKind: sigKind };
  }

  // a depth as the maker prints it: centimeters for Tempur-Pedic (with inches on wide drawings), inches for Purple
  function depthLabel(k, narrow) {
    if (k.cm) return narrow ? k.cm + ' cm' : k.cm + ' cm, ' + num(k.d) + ' in.';
    return num(k.d) + ' in.';
  }

  function coilRow(x, y, w, h, s, dbl, id) {
    // pocketed coils side on, one drawn once and repeated with <use>; double-stacked = two rows
    var pitch = 2 * s, n = Math.max(1, Math.floor(w / pitch)), off = (w - n * pitch) / 2, rows = dbl ? 2 : 1, o = [], r, k, rh = h / rows;
    o.push('<defs><g id="' + id + '">');
    for (r = 0; r < rows; r++) {
      var y0 = y + r * rh;
      o.push('<rect class="pk-pocket" fill="none" stroke="#4c4844" stroke-width="1" x="' + r1(-pitch / 2 + 1) + '" y="' + r1(y0 + 1.5) + '" width="' + r1(pitch - 2) + '" height="' + r1(rh - 3) + '" rx="' + r1(Math.min(pitch, rh) / 3) + '"/>');
      o.push('<polyline class="pk-wire" fill="none" stroke="#dde1e5" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round" points="' + zig(0, y0 + 4, y0 + rh - 4, pitch * 0.32, Math.max(2, Math.round(rh / s / 1.15))) + '"/>');
    }
    o.push('</g></defs>');
    for (k = 0; k < n; k++) o.push('<use href="#' + id + '" x="' + r1(x + off + pitch * k + pitch / 2) + '"/>');
    return o.join('');
  }

  function zig(cx, y0, y1, hw, n) {
    var pts = [], steps = n * 2, i, y, x;
    for (i = 0; i <= steps; i++) {
      y = y0 + (y1 - y0) * i / steps;
      x = (i === 0 || i === steps) ? cx : cx + (i % 2 ? hw : -hw);
      pts.push(r1(x) + ',' + r1(y));
    }
    return pts.join(' ');
  }

  function bedSvg(bed, x, g, side, brand) {
    var b = bands(bed, g), o = [], i, k, narrow = g.W < 400, mid = x + g.w / 2, ty = b.top, tag = (narrow ? 'n' : 'w') + side;
    o.push('<g class="pk-bed pk-bed--' + side + '" data-bed>');
    if (narrow) {
      o.push('<text class="pk-t1" x="' + mid + '" y="' + r1(ty - 38) + '" text-anchor="middle">' + esc(brand) + '</text>');
      o.push('<text class="pk-t2" x="' + mid + '" y="' + r1(ty - 23) + '" text-anchor="middle">' + esc(bed.short || bed.name) + '</text>');
      o.push('<text class="pk-t2 pk-t2b" x="' + mid + '" y="' + r1(ty - 8) + '" text-anchor="middle">' + num(bed.h) + ' in.</text>');
    } else {
      o.push('<text class="pk-t1" x="' + mid + '" y="' + r1(ty - 26) + '" text-anchor="middle">' + esc(brand) + ' <tspan class="pk-t1b">' + num(bed.h) + ' in.</tspan></text>');
      o.push('<text class="pk-t2" x="' + mid + '" y="' + r1(ty - 10) + '" text-anchor="middle">' + esc(bed.name) + '</text>');
    }
    for (i = 0; i < b.list.length; i++) {
      k = b.list[i];
      if (k.h < 0.4) continue;
      var cls = k.kind === 'np' ? 'pk-np' : 'pk-' + (KIND[k.kind] || 'fm');
      o.push('<rect class="pk-band ' + cls + '" style="--i:' + (b.list.length - i) + '" x="' + x + '" y="' + r1(k.y) + '" width="' + g.w + '" height="' + r1(k.h) + '"/>');
      if (k.kind === 'grid') o.push('<rect class="pk-gridw" x="' + x + '" y="' + r1(k.y) + '" width="' + g.w + '" height="' + r1(k.h) + '"/>');
      if (k.kind === 'coils' || k.kind === 'dstack') o.push(coilRow(x, k.y, g.w, k.h, g.s, k.kind === 'dstack', 'pkc-' + tag + i));
      if (k.kind === 'zone') o.push('<rect class="pk-zone" x="' + x + '" y="' + r1(k.y) + '" width="' + g.w + '" height="' + r1(k.h) + '"/>');
      if (k.kind === 'np') {
        if (k.coils && k.h > 3 * g.s) o.push('<g class="pk-ghost">' + coilRow(x, k.y + 2, g.w, k.h - 4, g.s, k.coils === 'dstack', 'pkg-' + tag) + '</g>');
        o.push('<rect class="pk-hatch" x="' + x + '" y="' + r1(k.y) + '" width="' + g.w + '" height="' + r1(k.h) + '"/>');
        if (k.h >= 14) {
          var nm = k.gap ? 'Cover and quilting' : shortNames(k.names);
          var lines = narrow ? (k.h >= 40 ? [shortNames(k.names, true), 'not published'] : ['Not published']) : (k.h >= 36 ? [nm, 'depth not published'] : [nm + ', not published']);
          var ly = k.y + k.h / 2 - (lines.length - 1) * 7 + 4;
          for (var j = 0; j < lines.length; j++) o.push('<text class="pk-npl" x="' + mid + '" y="' + r1(ly + j * 14) + '" text-anchor="middle">' + esc(lines[j]) + '</text>');
        }
      } else if (k.kind !== 'coils' && k.kind !== 'dstack' && k.h >= 14) {
        var word = WORD[k.kind] || 'Foam';
        if (k.kind === 'tempur' && /support/i.test(k.name)) word = 'TEMPUR support';
        if (/dreamlayer/i.test(k.name)) word = 'DreamLayer';
        if (/cool ?flex/i.test(k.name)) word = 'CoolFlex';
        var lab = narrow ? depthLabel(k, true) : word + ', ' + depthLabel(k, false);
        o.push('<text class="pk-ln' + (k.kind === 'base' || k.kind === 'grid' ? ' pk-ln--d' : '') + '" x="' + (x + (narrow ? 6 : 8)) + '" y="' + r1(k.y + k.h / 2 + 4) + '">' + esc(lab) + '</text>');
      }
    }
    o.push('<rect class="pk-edge" x="' + x + '" y="' + r1(b.top) + '" width="' + g.w + '" height="' + r1(g.floor - b.top) + '" rx="3"/>');
    o.push('</g>');
    return { svg: o.join(''), b: b };
  }

  function shortNames(names, narrow) {
    var t = names.map(function (n) { var w = String(n).split(' (')[0].split(',')[0]; return /coil/i.test(w) ? 'Coils' : w; }).join(' and ');
    if (narrow && t.length > 14) t = /coil/i.test(t) ? 'Coils' : (/base/i.test(t) ? 'Base' : 'Foam');
    return t.length > 28 ? t.slice(0, 26) : t;
  }

  // one red bracket per bed: the brand's own comfort material (the grid, the TEMPUR), at its published depth
  function bracket(bed, b, x, g, side) {
    if (!b.sig) return '';
    var o = [], out = side === 'a' ? -1 : 1, bx = side === 'a' ? x - g.bo : x + g.w + g.bo, tx = bx + out * 5, anc = side === 'a' ? 'end' : 'start';
    var y0 = null, y1 = null, i, k;
    for (i = 0; i < b.list.length; i++) {
      k = b.list[i];
      if (k.d != null && SIG[k.kind]) { if (y0 == null || k.y < y0) y0 = k.y; if (y1 == null || k.y + k.h > y1) y1 = k.y + k.h; }
    }
    if (y0 == null) return '';
    o.push('<path class="pk-br" d="M' + r1(bx - out * 4) + ' ' + r1(y0 + 1) + ' H' + r1(bx) + ' V' + r1(y1 - 1) + ' H' + r1(bx - out * 4) + '"/>');
    var my = (y0 + y1) / 2;
    var sigTxt = b.sigCm ? (Math.round(b.sig * 10) / 10).toFixed(1) + ' in.' : num(b.sig) + ' in.';
    o.push('<text class="pk-bn" x="' + r1(tx) + '" y="' + r1(my - 1) + '" text-anchor="' + anc + '">' + sigTxt + '</text>');
    o.push('<text class="pk-bl" x="' + r1(tx) + '" y="' + r1(my + g.f2 + 1) + '" text-anchor="' + anc + '">' + (b.sigKind === 'grid' ? 'Grid' : (g.W < 400 ? 'On top' : 'Comfort')) + '</text>');
    return o.join('');
  }

  function ruler(g, maxIn) {
    var o = [], i, y, top = Math.ceil(maxIn);
    o.push('<line class="pk-axis" x1="' + g.gx + '" y1="' + g.floor + '" x2="' + g.gx + '" y2="' + r1(g.floor - top * g.s) + '"/>');
    for (i = 0; i <= top; i++) {
      y = r1(g.floor - i * g.s);
      o.push('<line class="pk-tick' + (i % 4 ? '' : ' pk-tick--big') + '" x1="' + (g.gx - (i % 4 ? 3 : 6)) + '" y1="' + y + '" x2="' + (g.gx + (i % 4 ? 3 : 6)) + '" y2="' + y + '"/>');
      if (i % 4 === 0 && i > 0) {
        o.push('<line class="pk-grid" x1="' + (g.ax - 2) + '" y1="' + y + '" x2="' + (g.bx + g.w + 2) + '" y2="' + y + '"/>');
        o.push('<text class="pk-tl" x="' + (g.gx + (g.W < 400 ? 0 : 9)) + '" y="' + r1(g.W < 400 ? y - 5 : y + 4) + '"' + (g.W < 400 ? ' text-anchor="middle"' : '') + '>' + i + '</text>');
      }
    }
    o.push('<text class="pk-tl" x="' + g.gx + '" y="' + r1(g.floor + 14) + '" text-anchor="middle">in.</text>');
    o.push('<line class="pk-floor" x1="' + (g.ax - g.lab + 8) + '" y1="' + g.floor + '" x2="' + (g.bx + g.w + g.lab - 8) + '" y2="' + g.floor + '"/>');
    return o.join('');
  }

  // ------------------------------------------------------------------ the close-up (not to scale)
  function cuGeom(g, side) {
    var x = side === 'a' ? g.ax : g.bx, y0 = g.cy + 24, h = g.ch - 24;
    return { x: x, w: g.w, y0: y0, h: h, skin: 9, top: y0 + 9, bot: y0 + h - 14, base: y0 + h - 14, pitch: g.w / g.n, n: g.n, R: g.W < 400 ? 15 : 19 };
  }

  // a grid wall from its top (yt) to the base: straight, or bowed out by amp (clamped at both ends, so the bow is the
  // first clamped-clamped buckling shape, (1 - cos 2 pi t) / 2)
  function wallD(cx, yt, yb, amp) {
    if (Math.abs(amp) < 0.05) return 'M' + r1(cx) + ' ' + r1(yt) + ' V' + r1(yb);
    var p = [], i, t, steps = 12;
    for (i = 0; i <= steps; i++) { t = i / steps; p.push((i ? 'L' : 'M') + r1(cx + amp * (1 - Math.cos(2 * Math.PI * t)) / 2) + ' ' + r1(yt + (yb - yt) * t)); }
    return p.join(' ');
  }

  function bandPath(x, w, up, lo, steps) {
    var p = [], i, px;
    steps = steps || 36;
    for (i = 0; i <= steps; i++) { px = x + w * i / steps; p.push((i ? 'L' : 'M') + r1(px) + ' ' + r1(up(px))); }
    for (i = steps; i >= 0; i--) { px = x + w * i / steps; p.push('L' + r1(px) + ' ' + r1(lo(px))); }
    return p.join(' ') + 'Z';
  }

  // the surface of the grid row: eased between wall tops; dy[i] is how far wall i's top has dropped
  function gridSurf(c, dy) {
    return function (px) {
      var f = (px - c.x) / c.pitch - 0.5, i = Math.floor(f), t = f - i;
      if (f <= 0) return dy[0];
      if (i >= dy.length - 1) return dy[dy.length - 1];
      var e = (1 - Math.cos(t * Math.PI)) / 2;
      return dy[i] * (1 - e) + dy[i + 1] * e;
    };
  }

  // the dent in TEMPUR: wraps the puck (a circle of radius R) under it and spreads wide and smooth beyond it
  function tempurDip(c, mid, D) {
    var R = c.R, spread = c.pitch * 1.9;
    return function (px) {
      if (D <= 0.01) return 0;
      var dx = Math.abs(px - mid), cap = R - Math.sqrt(Math.max(0, R * R - Math.min(dx, R) * Math.min(dx, R)));
      var inner = D - cap * Math.min(1, D / R);
      if (dx <= R * 0.92) return Math.max(0, inner);
      var at = Math.max(0, D - (R - Math.sqrt(Math.max(0, R * R - R * R * 0.8464))) * Math.min(1, D / R));
      var u = (dx - R * 0.92) / spread;
      return at * Math.exp(-u * u * 1.6);
    };
  }

  // static parts of each close-up; the moving parts are drawn by drawCu() from a state
  function closeup(bed, g, side, st) {
    var c = cuGeom(g, side), o = [], kind = side === 'a' ? 'grid' : 'tempur';
    o.push('<g class="pk-cu pk-cu--' + side + '" data-cu="' + side + '" data-kind="' + kind + '">');
    o.push('<rect class="pk-cu__base" x="' + c.x + '" y="' + r1(c.base) + '" width="' + c.w + '" height="14" rx="2"/>');
    o.push('<g data-cu-dyn>' + drawCu(kind, c, st) + '</g>');
    o.push('</g>');
    return o.join('');
  }

  // st: { load: 0..1 pressed depth factor, at: 0..1 position, walls: [compression 0..1], dent: px, heat: 0..1, ghost: px, puck: px }
  function drawCu(kind, c, st) {
    var o = [], i, mid = c.x + st.at * c.w, free = c.base - c.top;
    if (kind === 'grid') {
      var dy = [], walls = st.walls || [];
      for (i = 0; i < c.n; i++) dy.push((walls[i] || 0) * free);
      var gs = gridSurf(c, dy), k = Math.max(0, Math.min(1, (st.lift || 0) / 26)), bot = gs(mid);
      // the cover drapes over the load while it presses; once the hand lifts it follows the wall tops alone
      var surf = k > 0.05 ? gs : function (px) {
        var dx = Math.abs(px - mid);
        return dx < c.R ? Math.max(gs(px), bot - (c.R - Math.sqrt(c.R * c.R - dx * dx))) : gs(px);
      };
      o.push('<path class="pk-cu__cells" d="' + bandPath(c.x, c.w, function (px) { return c.top + surf(px); }, function () { return c.base; }) + '"/>');
      for (i = 0; i < c.n; i++) {
        var cx = c.x + c.pitch * (i + 0.5), comp = walls[i] || 0, yt = c.top + dy[i], L = c.base - yt;
        // shortening of a bowed wall: amp = (2 / pi) * sqrt(drop * remaining length), kept inside its cell
        var amp = comp > 0.004 ? Math.min(c.pitch * 0.46, (2 / Math.PI) * Math.sqrt(dy[i] * L)) : 0;
        var dir = cx < mid ? -1 : 1;
        o.push('<path class="pk-wall' + (comp > 0.08 ? ' is-buckled' : '') + '" d="' + wallD(cx, yt, c.base, dir * amp) + '"/>');
      }
      o.push('<path class="pk-cu__skin pk-cu__skin--a" d="' + bandPath(c.x, c.w, function (px) { return c.y0 + surf(px); }, function (px) { return c.top + surf(px); }) + '"/>');
      o.push(puck(c, mid, c.y0 + bot, k));
    } else {
      var dip = tempurDip(c, st.dentAt != null ? c.x + st.dentAt * c.w : mid, st.dent || 0);
      var slab = bandPath(c.x, c.w, function (px) { return c.top + dip(px); }, function () { return c.base; });
      o.push('<path class="pk-cu__tp" d="' + slab + '"/>');
      if (st.heat > 0.02) {
        // warmth stays inside the foam: the glow is clipped to the slab
        var hx = st.dentAt != null ? c.x + st.dentAt * c.w : mid, cid = 'pkclip-' + Math.round(c.x) + '-' + Math.round(c.w);
        o.push('<clipPath id="' + cid + '"><path d="' + slab + '"/></clipPath>');
        o.push('<ellipse class="pk-heat" clip-path="url(#' + cid + ')" cx="' + r1(hx) + '" cy="' + r1(c.top + (st.dent || 0) * 0.9 + 4) + '" rx="' + r1(c.pitch * 2.2) + '" ry="' + r1(free * 0.55) + '" opacity="' + r1(Math.min(1, st.heat) * 10) / 10 + '"/>');
      }
      if (st.ghost > 1.5 && st.ghost > (st.dent || 0) + 1) {
        var gd = tempurDip(c, st.dentAt != null ? c.x + st.dentAt * c.w : mid, st.ghost);
        o.push('<path class="pk-ghostline" d="' + linePath(c.x, c.w, function (px) { return c.y0 + gd(px); }) + '" opacity="' + r1(Math.min(1, (st.ghost - st.dent) / 10)) + '"/>');
      }
      o.push('<path class="pk-cu__skin pk-cu__skin--b" d="' + bandPath(c.x, c.w, function (px) { return c.y0 + dip(px); }, function (px) { return c.top + dip(px); }) + '"/>');
      o.push(puck(c, mid, c.y0 + dip(mid), Math.max(0, Math.min(1, (st.lift || 0) / 26))));
    }
    return o.join('');
  }

  // the load: resting in the surface while it presses (k = 0), lifted clear above it as the hand lets go (k = 1)
  function puck(c, mid, contact, k) {
    var bottom = Math.min(contact, contact * (1 - k) + (c.y0 - 4) * k), op = (1 - k) * (1 - k);
    if (op < 0.05) return '';
    return '<circle class="pk-puck" cx="' + r1(mid) + '" cy="' + r1(bottom - c.R) + '" r="' + c.R + '"' + (op < 0.98 ? ' opacity="' + r1(op * 10) / 10 + '"' : '') + '/>';
  }

  function linePath(x, w, f) {
    var p = [], i, steps = 36, px;
    for (i = 0; i <= steps; i++) { px = x + w * i / steps; p.push((i ? 'L' : 'M') + r1(px) + ' ' + r1(f(px))); }
    return p.join(' ');
  }

  // the pressed state the still shows: the load set down at the middle and held
  function settledState(kind, g, load) {
    var c = cuGeom(g, kind === 'grid' ? 'a' : 'b'), st = { at: 0.5, lift: 0, heat: 0, dent: 0, ghost: 0, walls: [] };
    if (kind === 'grid') { for (var i = 0; i < c.n; i++) st.walls.push(wallGoal(c, i, 0.5, load)); }
    else { st.dent = dentGoal(c, load, 1); st.heat = load ? 0.85 : 0; }
    return st;
  }

  // how deep the load presses (px) for a load of 1; held longer, it presses a little harder
  function pressDepth(c, load) { return Math.min(0.66, 0.46 * load) * (c.base - c.top); }

  // a GelFlex Grid wall under the load. A wall the load touches buckles, and once buckled it folds at a nearly
  // constant force, so the walls under the load give until the load sits as deep as it presses; a wall it does not
  // touch takes almost nothing and stands straight. Returns the wall's compression (0..1 of its free height).
  function wallGoal(c, i, f, load) {
    if (load <= 0.001) return 0;
    var cx = c.x + c.pitch * (i + 0.5), dx = Math.abs(cx - (c.x + f * c.w)), D = pressDepth(c, load), free = c.base - c.top;
    if (dx >= c.R) return Math.min(0.02, 0.02 * load * Math.exp(-Math.pow((dx - c.R) / c.pitch, 2)));
    var need = D - (c.R - Math.sqrt(c.R * c.R - dx * dx));
    return Math.max(0, need) / free;
  }

  // how deep TEMPUR settles under the load. The warmth drawn where it is pressed changes nothing in the depth:
  // Tempur-Pedic says the material responds to temperature, not that it softens as it warms.
  function dentGoal(c, load) { return pressDepth(c, load) * 0.95; }

  function maxH(data) {
    var m = 0, k;
    for (k in data.beds) if (data.beds[k].h > m) m = data.beds[k].h;
    return m || 16;
  }

  function svg(data, idA, idB, narrow, compact) {
    var g = G(narrow), A = data.beds[idA], B = data.beds[idB];
    if (!A || !B) return '';
    var mh = maxH(data), vy = Math.floor(g.floor - mh * g.s - (narrow ? 54 : 40)), H = g.cy + g.ch + (narrow ? 50 : 36) - vy, tag = narrow ? 'n' : 'w';
    var o = ['<svg class="pk ' + (narrow ? 'pk--narrow' : 'pk--wide') + (compact ? ' pk--still' : '') + '" viewBox="0 ' + vy + ' ' + g.W + ' ' + H + '" width="' + g.W + '" height="' + H + '" role="img" aria-label="' + esc(data.a + ' ' + A.name + ', ' + num(A.h) + ' inches, beside ' + data.b + ' ' + B.name + ', ' + num(B.h) + ' inches, cut open to scale. Under them, the same press on both: the Grid walls under it buckle while the walls beside it stand; TEMPUR takes a wide dent.') + '" data-pair="' + esc(idA + ' ' + idB) + '">'];
    o.push('<defs><pattern id="pkh-' + tag + '" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="6" class="pk-hl"/></pattern>' +
      '<pattern id="pkw-' + tag + '" width="' + r1(g.s * 0.75) + '" height="10" patternUnits="userSpaceOnUse"><rect x="0" y="0" width="1.6" height="10" class="pk-gl"/></pattern>' +
      '<pattern id="pkz-' + tag + '" width="10" height="10" patternUnits="userSpaceOnUse"><line x1="5" y1="0" x2="5" y2="10" class="pk-zl"/></pattern>' +
      '<radialGradient id="pkr-' + tag + '"><stop offset="0" stop-color="#ff7a45" stop-opacity=".78"/><stop offset=".55" stop-color="#ff9a5c" stop-opacity=".32"/><stop offset="1" stop-color="#ffb36b" stop-opacity="0"/></radialGradient></defs>');
    o.push('<g class="pk-fill" style="--h:url(#pkh-' + tag + ');--gw:url(#pkw-' + tag + ');--z:url(#pkz-' + tag + ');--heat:url(#pkr-' + tag + ')">');
    o.push(ruler(g, mh));
    var a = bedSvg(A, g.ax, g, 'a', data.a), b = bedSvg(B, g.bx, g, 'b', data.b);
    o.push(a.svg, b.svg, bracket(A, a.b, g.ax, g, 'a'), bracket(B, b.b, g.bx, g, 'b'));
    o.push('<text class="pk-cuh" x="' + (g.ax + g.w / 2) + '" y="' + (g.cy + 9) + '" text-anchor="middle">' + (narrow ? 'Grid' : 'GelFlex Grid') + '</text>');
    o.push('<text class="pk-cuh" x="' + (g.bx + g.w / 2) + '" y="' + (g.cy + 9) + '" text-anchor="middle">' + (narrow ? 'TEMPUR' : 'TEMPUR-Material') + '</text>');
    o.push(closeup(A, g, 'a', settledState('grid', g, 1)), closeup(B, g, 'b', settledState('tempur', g, 1)));
    // what each one does, under its close-up (two short lines on phones)
    var capA = narrow ? ['Only the columns', 'under it buckle'] : ['Only the columns under it buckle'];
    var capB = narrow ? ['A wide dent,', 'slow in, slow out'] : ['A wide dent, slow in and slow out'];
    var yc = g.cy + g.ch + 17, i;
    for (i = 0; i < capA.length; i++) o.push('<text class="pk-cap" x="' + (g.ax + g.w / 2) + '" y="' + (yc + i * 14) + '" text-anchor="middle">' + capA[i] + '</text>');
    for (i = 0; i < capB.length; i++) o.push('<text class="pk-cap" x="' + (g.bx + g.w / 2) + '" y="' + (yc + i * 14) + '" text-anchor="middle">' + capB[i] + '</text>');
    o.push('<text class="pk-cul" x="' + g.gx + '" y="' + (yc + capA.length * 14 + 6) + '" text-anchor="middle">' + (narrow ? 'The same press on both. Not to scale.' : 'The same press on both, close up. Not to scale.') + '</text>');
    o.push('</g></svg>');
    return o.join('');
  }

  var api = { svg: svg, G: G, bands: bands, cuGeom: cuGeom, drawCu: drawCu, wallGoal: wallGoal, pressDepth: pressDepth, dentGoal: dentGoal, settledState: settledState };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  window.MOPvtCut = api;

  /* ------------------------------------------------------------------ the page */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot(fig) {
    var stage = fig.querySelector('[data-pvt-stage]');
    var dataEl = fig.querySelector('[data-pvt-data]');
    if (!stage || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var root = fig.closest('[data-mo-pvt]');
    var pair = { a: stage.getAttribute('data-a'), b: stage.getAttribute('data-b') };
    var narrow = null, sides = null, raf = 0, visible = true, lastT = 0, holdT = 0;
    // one shared load: pressed (0 or 1, more while held), where it sits (0..1), and the hand's height when lifted
    var S = { press: 1, target: 1, held: 0, at: 0.5, atGoal: 0.5, lift: 0 };

    function isNarrow() { return stage.clientWidth < 520; }

    function render(force) {
      var nw = isNarrow();
      if (!force && nw === narrow && stage.getAttribute('data-drawn') === pair.a + ' ' + pair.b) return;
      narrow = nw;
      stage.innerHTML = svg(data, pair.a, pair.b, nw);
      stage.setAttribute('data-drawn', pair.a + ' ' + pair.b);
      var g = G(nw);
      sides = ['a', 'b'].map(function (sd) {
        var el = stage.querySelector('[data-cu="' + sd + '"] [data-cu-dyn]');
        var kind = sd === 'a' ? 'grid' : 'tempur', c = cuGeom(g, sd), st = settledState(kind, g, S.press);
        st.lift = S.press > 0.01 ? 0 : 26; st.v = []; st.ghost = 0; st.dentAt = S.at; st.dv = 0;
        for (var i = 0; i < c.n; i++) st.v.push(0);
        return { el: el, kind: kind, c: c, st: st, last: '' };
      });
      draw();
    }

    function draw() {
      if (!sides) return;
      sides.forEach(function (sd) {
        if (!sd.el) return;
        sd.st.at = S.at;
        sd.st.lift = S.lift;
        var html = drawCu(sd.kind, sd.c, sd.st);
        if (html !== sd.last) { sd.el.innerHTML = html; sd.last = html; }
      });
    }

    // one physics step of h seconds; returns true while anything still moves
    function advance(h, t) {
      if (S.held) S.target = Math.min(1.45, 1 + (t - holdT) / 2600);
      S.press += (S.target - S.press) * Math.min(1, h * 9);
      S.at += (S.atGoal - S.at) * Math.min(1, h * 12);
      // the hand: on the surface while pressing, lifted clear when it lets go
      var liftGoal = S.target > 0.01 ? 0 : 26;
      S.lift += (liftGoal - S.lift) * Math.min(1, h * (liftGoal ? 11 : 30));
      var moving = Math.abs(S.target - S.press) > 0.002 || Math.abs(S.atGoal - S.at) > 0.001 || Math.abs(liftGoal - S.lift) > 0.3;
      (sides || []).forEach(function (sd) {
        var st = sd.st, c = sd.c, i;
        if (sd.kind === 'grid') {
          for (i = 0; i < c.n; i++) {
            var goal = wallGoal(c, i, S.at, S.press);
            var a = (goal - st.walls[i]) * 900 - st.v[i] * 38;      // stiff and quick: springs straight at once
            st.v[i] += a * h; st.walls[i] += st.v[i] * h;
            if (st.walls[i] < 0) { st.walls[i] = 0; if (st.v[i] < 0) st.v[i] *= -0.25; }
            if (Math.abs(st.v[i]) > 0.002 || Math.abs(goal - st.walls[i]) > 0.002) moving = true;
          }
        } else {
          // TEMPUR: a slow material (Tempur-Pedic: "a unique viscous response"). It sinks in over about a second, warms where it is pressed, and
          // fills back in over a few seconds once the load lifts; the dashed line marks the deepest the dent went.
          var pressing = S.target > 0.01;
          st.heat += ((pressing ? 1 : 0) - st.heat) * Math.min(1, h / (pressing ? 2.2 : 2.5));
          var dg = dentGoal(c, S.press, st.heat);
          var tau = dg > st.dent ? 0.75 : 1.6;
          if (pressing) st.dentAt += (S.at - st.dentAt) * Math.min(1, h * 1.6);
          st.dent += (dg - st.dent) * Math.min(1, h / tau);
          if (pressing) st.ghost = Math.max(st.ghost, st.dent); else st.ghost += (0 - st.ghost) * Math.min(1, h / 2.2);
          if (Math.abs(dg - st.dent) > 0.15 || (!pressing && (st.heat > 0.03 || st.ghost > 1.5)) || (pressing && Math.abs(S.at - st.dentAt) > 0.002)) moving = true;
          if (!pressing && st.dent < 0.4 && st.heat < 0.04) { st.dent = 0; st.heat = 0; st.ghost = 0; }
        }
      });
      return moving;
    }

    // real time, in fixed sub-steps, so a slow frame rate never slows the materials down
    function step(t) {
      raf = 0;
      var dt = Math.min(0.1, lastT ? (t - lastT) / 1000 : 0.016), n = Math.max(1, Math.ceil(dt / 0.012)), moving = false, k;
      lastT = t;
      for (k = 0; k < n; k++) moving = advance(dt / n, t) || moving;
      draw();
      if ((moving || S.held) && visible) raf = requestAnimationFrame(step);
      else lastT = 0;
    }

    function kick() { if (!raf && visible && !reduce) { lastT = 0; raf = requestAnimationFrame(step); } }

    function snap() {   // reduced motion: jump to the end state of the current load
      (sides || []).forEach(function (sd) {
        var st = sd.st, c = sd.c, i, on = S.target > 0.01;
        if (sd.kind === 'grid') for (i = 0; i < c.n; i++) { st.walls[i] = wallGoal(c, i, S.atGoal, S.target); st.v[i] = 0; }
        else { st.heat = on ? 0.85 : 0; st.dentAt = S.atGoal; st.dent = on ? dentGoal(c, S.target, st.heat) : 0; st.ghost = 0; }
      });
      S.press = S.target; S.at = S.atGoal; S.lift = S.target > 0.01 ? 0 : 26;
      draw();
    }

    function press(on) {
      if (on) { S.held = 1; holdT = performance.now(); S.target = 1; }
      else { S.held = 0; S.target = 0; }
      fig.classList.toggle('is-pressing', !!on);
      if (reduce) snap(); else kick();
    }

    var btn = fig.querySelector('[data-pvt-press]');
    if (btn) {
      btn.addEventListener('pointerdown', function (e) { if (e.button === 0) { btn.setPointerCapture && btn.setPointerCapture(e.pointerId); press(true); } });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { btn.addEventListener(ev, function () { if (S.held) press(false); }); });
      btn.addEventListener('keydown', function (e) {
        if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); press(true); return; }
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        S.atGoal = Math.max(0.12, Math.min(0.88, S.atGoal + (e.key === 'ArrowLeft' ? -0.19 : 0.19)));
        if (reduce) snap(); else kick();
      });
      btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); press(false); } });
      btn.addEventListener('click', function (e) { if (e.detail === 0 && !S.held) { press(true); setTimeout(function () { press(false); }, 900); } });
    }
    function aim(e) {
      var sv = stage.querySelector('svg.pk'), m = sv && sv.getScreenCTM && sv.getScreenCTM();
      if (!m || !sides) return;
      var x = (e.clientX - m.e) / m.a, f = null;
      sides.forEach(function (sd) { if (x >= sd.c.x - 10 && x <= sd.c.x + sd.c.w + 10) f = (x - sd.c.x) / sd.c.w; });
      if (f != null) { S.atGoal = Math.max(0.12, Math.min(0.88, f)); if (reduce) S.at = S.atGoal; }
    }
    stage.addEventListener('pointerdown', function (e) { if (e.button === 0) { stage.setPointerCapture && stage.setPointerCapture(e.pointerId); aim(e); press(true); } });
    stage.addEventListener('pointermove', function (e) { if (S.held) { aim(e); if (reduce) snap(); else kick(); } });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { stage.addEventListener(ev, function () { if (S.held) press(false); }); });

    // one orchestrated moment on first view: the still shows both pressed; the load lifts, the Grid springs straight
    // at once and TEMPUR fills back in slowly. Then it waits for the shopper.
    function intro() {
      fig.classList.add('is-shown');
      if (reduce) return;
      if (fig.classList.contains('is-armed')) fig.classList.add('is-built');
      setTimeout(function () { if (!S.held) { S.target = 0; kick(); } }, fig.classList.contains('is-armed') ? 1500 : 1100);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) { kick(); if (!fig.classList.contains('is-shown')) intro(); }
      }, { threshold: 0.3 }).observe(fig);
    }

    // the panel sticks under the site header; when the header is not sticky (print, slice captures) neither is the panel
    var hdr = document.querySelector('.shopify-section-group-header-group'), stT = 0;
    function stickCheck() {
      stT = 0;
      if (!hdr) return;
      var p = getComputedStyle(hdr).position, un = !(p === 'sticky' || p === 'fixed');
      var host = root || fig;
      if (un !== host.classList.contains('is-unstuck')) host.classList.toggle('is-unstuck', un);
    }
    window.addEventListener('scroll', function () { if (!stT) stT = setTimeout(stickCheck, 300); }, { passive: true });
    stickCheck();

    var rz = 0;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { render(false); }, 120); });

    if (root) root.addEventListener('mo-pvt:pair', function (e) {
      pair = { a: e.detail.a, b: e.detail.b };
      stage.setAttribute('data-a', pair.a); stage.setAttribute('data-b', pair.b);
      render(true);
      fig.querySelectorAll('[data-pvt-key]').forEach(function (k) {
        var id = k.getAttribute('data-pvt-key');
        k.hidden = !(id === pair.a || id === pair.b);
      });
      if (!reduce) { fig.classList.remove('is-built'); fig.classList.add('is-armed'); void fig.offsetWidth; fig.classList.add('is-built'); }
    });

    render(false);
    var r0 = fig.getBoundingClientRect();
    if (!reduce && r0.top > innerHeight * 0.8) fig.classList.add('is-armed');
    fig.classList.add('is-live');
    fig.__pvt = { S: S, sides: function () { return sides; }, press: press };
  }

  function init() { document.querySelectorAll('[data-pvt-cut]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
